import React from 'react';
import c from 'classnames';
const Callout = props => {
  const {
    children,
    className
  } = props;
  const classNames = c('Callout', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "Callout__Content"
  }, children));
};
export default Callout;